import React from "react";
import Hero from "./components/Home/Hero";
import CreativeButterfly from "./components/Home/CreativeButterfly";
import MarqueeMenu from "./components/Marquee/MarqueeMenu";
// import About from './components/Home/About'
import ShapeOverlayMenu from "./components/Navbar/ShapeOverlayMenu";
import Gallery from "./components/Home/Gallery";
import Footer from "./components/Footer/Footer";
// import RagDoll from './components/Home/RagDoll/RagDoll'
import { useLenis } from "./hooks/useLenis"; // adjust the path as needed

export const AppHome = () => {
  useLenis();
  return (
    <div className="flex flex-col relative bg-[var(--home-bg)] overflow-x-hidden">
      <ShapeOverlayMenu />
      {/* <Hero /> */}
      <CreativeButterfly />
      {/* <About /> */}
      <div className="relative overflow-hidden mt-[100px] h-[calc(200vh+1000px)]">
        <Gallery />
      </div>
      {/* <MarqueeMenu /> */}
      <Footer />
      {/* <RagDoll /> */}
    </div>
  );
};
